import React, { useState, useEffect, useRef } from "react";
import {
    CloseButtonWrapper,
    ModalContent,
    ModalDiv,
    StyledIframe,
} from "./StyledComponents";
import CloseButton from "../../../assets/SVGComponents/CloseButton";

function WatchVideoModal({ activeVideo, link, closeFunction }) {
    const [lightboxLink, setLightboxLink] = useState(null);
    const modalRef = useRef();
    useEffect(() => {
        if (link) {
            setLightboxLink(link);
        }
    }, [link]);

    return activeVideo ? (
        <ModalDiv
            ref={modalRef}
            id={"fod-watch-video-modal"}
            className="FODWatchVideoModalOuterWrapper"
            onClick={() => {
                closeFunction();
            }}
        >
            <ModalContent className="FODWatchVideoModalContentWrapper">
                <CloseButtonWrapper
                    data-testid="close_button"
                    data-asceventact="close"
                    className="FODWatchVideoModalCloseButtonWrapper FODV5GAWatchVideoCloseButton"
                    onClick={() => {
                        closeFunction();
                    }}
                >
                    <CloseButton svgIconSize={"40px"} />
                </CloseButtonWrapper>
                <StyledIframe
                    src={lightboxLink}
                    title="Video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    className="FODWatchVideoModalFrame"
                    allowFullScreen
                    loading="lazy"
                />
            </ModalContent>
        </ModalDiv>
    ) : null;
}

export default WatchVideoModal;
